import { render, staticRenderFns } from "./trendingProducts.vue?vue&type=template&id=9e293d5c&scoped=true"
import script from "./trendingProducts.vue?vue&type=script&lang=js"
export * from "./trendingProducts.vue?vue&type=script&lang=js"
import style0 from "./trendingProducts.vue?vue&type=style&index=0&id=9e293d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e293d5c",
  null
  
)

export default component.exports